
<template>
    <div  >
      <div class="flx-center">
          <div class="platformBackground" :style="{ background: 'url(' + $ossUrl + 'images/head_img3.jpg) no-repeat center' }"></div>
        </div>
        <div class="platform">
        <!-- AMZ注册 -->
        <div class="container" >
          <div class=" button-group">
              <div class="button-group-item"  style="position: absolute;top:800px;">
                <el-button
                 v-for="(item, index) in buttons"
                 :key="index"
                 :class="{ 'active': activeIndex === index }"
                 @click="setActive(item,index)"
               >
                 <div class="btn-text" style="">
                  {{ item.label }}
                </div>
               </el-button>
              </div>
             </div>
             <el-row  style="padding:0 10px;">
              <el-col :span="8" class="flx-center">
                <div class="AMZBox flx-justify-between" @click="$router.push({path:'/AMZDetail?select=TSPN'})">
                 <div class=" flx-wrap ">
                     <div class="AMZtitle"> 亚马逊</div>
                     <div class="AMZcontent"> TSPN</div>
                   </div>
                   <div>
                     <img :src="$ossUrl+'icons/right.png'" alt="">
                   </div>
               </div>
              </el-col>
              <el-col :span="8" class="flx-center">
                <div class="AMZBox flx-justify-between" @click="$router.push({path:'/AMZDetail?select=SHIPTRACK'})">
                 <div class=" flx-wrap ">
                     <div class="AMZtitle"> 亚马逊</div>
                     <div class="AMZcontent"> SHIPTRACK</div>
                   </div>
                   <div>
                     <img :src="$ossUrl+'icons/right.png'" alt="">
                   </div>
               </div>
              </el-col>
              <el-col :span="8" class="flx-center">
                <div class="AMZBox flx-justify-between" @click="$router.push({path:'/AMZDetail?select=SEND'})">
                 <div class=" flx-wrap ">
                     <div class="AMZtitle"> 亚马逊</div>
                     <div class="AMZcontent"> SEND</div>
                   </div>
                   <div>
                     <img :src="$ossUrl+'icons/right.png'" alt="">
                   </div>
               </div>
              </el-col>
             </el-row>
             <div>
              <div class="AMZ-About">
                <div class="AMZ-AboutTitle" style="margin-bottom: 40px;"> 关于亚马逊</div>
                <div class="AMZ-AboutContent">
                  亚马逊成立于1995年7月，总部在美国西雅图。2015年，亚马逊全球开店业务进入中国，旨在借助亚马逊全球资源，帮助中国卖家抓住跨境电商新机遇，发展出口业务，拓展全球市场，打造国际品牌。目前，亚马逊美国、加拿大、墨西哥、英国、法国、德国、意大利、西班牙、荷兰、瑞典、比利时、日本、新加坡、澳大利亚、印度、阿联酋、沙特、波兰和巴西等19大海外站点已面向中国卖家开放，吸引数十万中国卖家入驻。
                </div>
              </div>
             </div>
          </div>
          <div style="background: #F8F8F8;">
          <div class="container" >
            <div class="special" style="padding: 80px 0px 30px 40px;">
              <div class="AMZ-AboutTitle">注册准备</div>
              <el-tabs v-model="activeRegistar" >
                 <el-tab-pane label="注册资料" name="first">
                  <registrateInfo></registrateInfo>
                 </el-tab-pane>
                 <el-tab-pane label="其他材料" name="second">
                  <otherInfo></otherInfo>
                 </el-tab-pane>
                 <el-tab-pane label="欧洲KYC" name="third">
                  <KYC></KYC>
                 </el-tab-pane>
                 <el-tab-pane label="账户审核“二审”" name="fourth">
                  <accountAudit></accountAudit>
                 </el-tab-pane>
               </el-tabs>
            </div>
          </div>
         </div> 
         <div class="container" style="margin-top: 80px;">
          <div class="AMZ-AboutTitle">注册流程</div>
          <div class="flx-justify-between" style="padding: 0 40px;">
            <div class="flowBox">
              <div class="flowNum">01</div>
              <div class="flowContent">提交开店申请登记表</div>
            </div>
            <img :src="$ossUrl+'icons/greenRight.png'" alt="">
            <div class="flowBox">
              <div class="flowNum">02</div>
              <div class="flowContent">发放注册链接至邮箱
                 <el-tooltip popper-class="flowContentTipCommonUI" class="flowContentTip" effect="light" placement="top-end">
                  <img style="width: 20px;height: 20px;" :src="$ossUrl+'icons/platform/tips.png'" alt="">
                  <div slot="content">
                    <div style="color: #1C1F35;font-size: 20px;font-weight: 500;line-height: 22px; margin-bottom:13px">提示</div>
                    若收到亚马逊大客户运营经理邮件。需额外补充资料信息，<br>
                    请尽快按照要求回复，齐全井符合要求后发放注册链接；
                    
                  </div>
                </el-tooltip>
              </div>
            </div>
            <img :src="$ossUrl+'icons/greenRight.png'" alt="">
            <div class="flowBox">
              <div class="flowNum">03</div>
              <div class="flowContent">点击链接开始注册
              <el-tooltip popper-class="flowContentTipCommonUI" class="flowContentTip" effect="light" placement="top-end">
                  <img style="width: 20px;height: 20px;" :src="$ossUrl+'icons/platform/tips.png'" alt="">
                  <div slot="content">
                    <div style="color: #1C1F35;font-size: 20px;font-weight: 500;line-height: 22px; margin-bottom:13px">提示</div>
                    账户创建的邮箱与申请登记时提供的邮箱保持一致。<br>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="flowTime">1-3个工作日</div>
          <div class="flx-justify-around" style="padding: 0 270px;">
            <div class="flowBox">
              <div class="flowNum">04</div>
              <div class="flowContent">资质审核结果通知</div>
            </div>
            <div style="width: 250px;text-align: center;">
            <img :src="$ossUrl+'icons/greenRight.png'" alt="">
            </div>
            <div class="flowBox">
              <div class="flowNum">05</div>
              <div class="flowContent">审核通过，上架商品
                 <el-tooltip popper-class="flowContentTipCommonUI" class="flowContentTip" effect="light" placement="top-end">
                  <div slot="content">
                    若收到亚马逊大客户运营经理邮件。<br>
                    需额外补充资料信息，请尽快按照要求回复，<br>
                    齐全井符合要求后发放注册链接；
                  </div>
                </el-tooltip>
              </div>
            </div>
        
          </div>
          <div>
            <div class="authority-title">官方经理提示</div>
            <div class="authority-content">
              <div>1.欧/美/日/澳印度/中东/新加坡18大站点均可登记,一周内下链接。一套资料一个邮箱可开通欧/美/日/澳/中东/新加坡17大站点，共享一份月租39.99美金;印度需提供不同邮箱申请；</div>
              <div>2.提交开店申请登记表时主要填写 <span>公司营业执照、法人姓名、手机号、邮箱地址、计划运营的目标站点、主营类目以及相关产品图片</span>等信息，可先登记后同步准备其他注册资料； </div>
              <div>3.申请链接时 请按实际情况填写登记表，工厂或产品报告/海外商标等材料如可提供请填写；</div>
            </div>
          </div>
         </div>
         <div class="footer_BOX"  style=" ">
          <div class="container flx-only-align-center footer_BOX_content" :style="{ background: 'url(' + $ossUrl + 'images/Amz/AMZ_footer_back.jpg) no-repeat center' }" style="position: relative;height: 100%;">
            <div>
              <div class="writeQrcode">扫码填写</div>
              <div class="MT-form">美通-亚马逊开店申请登记表</div>
            </div>
            <div class="footer-img" >
              <img :src="$ossUrl+'images/footer/qrcodeAMZ.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import accountAudit from "./components/accountAudit.vue";
  import otherInfo from "./components/otherInfo.vue";
  import registrateInfo from "./components/registrateInfo.vue";
  import KYC from "./components/KYC.vue";
  
  /**
   * Index-1 component
   */
  export default {
      name:"sea",
    components: {
      KYC,
      registrateInfo,
      otherInfo,
      accountAudit,
    },
    data(){
      return {
        activeName:'first',
        activeRegistar:'first',
        activeIndex: 1, // 默认选中第一个按钮
        buttons: [
          { label: '亚马逊仓库地址',transportMode:'OCEAN' },
          // { label: '仓库地址分布图',transportMode:'AIR' },
          { label: 'AMAZON注册',transportMode:'RAIL' }
        ]
      }
    },
    methods: {
        setActive(item,index) {
          console.log(item,index,'item,index')
        if(index === 0){
          this.$router.push({
            name:'platform'
          })
        }
        else if(index === 1){
          this.$router.push({
            name:'AMAZON'
          })
          // this.$router.push({
          //   name:'warehouseMap'
          // })
        }
        // else if(index === 2){
        //   this.$router.push({
        //     name:'AMAZON'
        //   })
        // }
        // this.activeIndex = index;
        
  
      },
    }
  };
  </script>
  <style >
  .flowContentTipCommonUI  {
      border: 1px solid #fff !important;
      filter: drop-shadow(0px 4px 81.7px #DDD);
      width: 356px;
      /* box-shadow: 0px 4px 81.7px #DDD; */
    }
  .flowContentTipCommonUI  .popper__arrow{
    border-top-color: #fff !important;
    border-bottom-color: #fff !important;
  }
  .flowContentTipCommonUI   .popper__arrow:after {
    border-top-color: #fff !important;
    border-bottom-color: #fff !important;
  }
  .el-tooltip__popper {
    padding: 28px !important;
  }
</style>
<style src="../index.css" scoped>
  
  
  </style>